// src/hooks/index.js
// Hooks personnalisés HmongHearts

import { useState, useEffect, useCallback } from 'react';

/**
 * Hook pour la gestion des modales (fermeture Escape + backdrop + scroll lock)
 */
export const useModal = (open, close) => {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = 'hidden';
    const h = (e) => e.key === 'Escape' && close();
    document.addEventListener('keydown', h);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', h);
    };
  }, [open, close]);

  return { onBackdrop: (e) => e.target === e.currentTarget && close() };
};

/**
 * Hook pour les notifications toast
 */
export const useToast = () => {
  const [t, setT] = useState([]);

  const add = useCallback((m, y = 'success') => {
    const id = Date.now();
    setT((p) => [...p, { id, m, y }]);
    setTimeout(() => setT((p) => p.map((x) => (x.id === id ? { ...x, leaving: true } : x))), 2800);
    setTimeout(() => setT((p) => p.filter((x) => x.id !== id)), 3000);
  }, []);

  return { t, add };
};

/**
 * Hook pour le mode sombre
 */
export const useDarkMode = () => {
  const [dark, setDark] = useState(() => {
    const stored = localStorage.getItem('hmh-dark-mode');
    if (stored !== null) return stored === 'true';
    return false;
  });

  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('hmh-dark-mode', String(dark));
  }, [dark]);

  const toggle = useCallback(() => setDark((d) => !d), []);

  return { dark, toggle };
};
